import { notEmpty } from '@pcmp-checka/lib-utilities/array';

export const initials = (text: string) =>
  text
    .split(' ')
    .filter(notEmpty)
    .map((word) => word[0].toUpperCase())
    .join('');
